
const EmailRegisterIcon = ({
    color = '#000',
    fondo = '#fff',
    vetor_css = { fontSize: '50px' },
    main_css = { width: '40px', padding: '0px' }
}) => {

    return (
        <svg className="" xmlns="http://www.w3.org/2000/svg" style={main_css} viewBox="0 0 18750 18300">
        <g id="l6KX8qy1PDDvW9kuYUVSux7" fill={'url(#gradienteRojoAzul)'}  style={vetor_css}>
            <g style={{transform: "none"}}>
                <path id="pvSLeqcpV" d="M2016 17735 c282 -331 5060 -5884 5064 -5884 3 -1 488 366 1078 814 590 448 1077 815 1082 815 5 0 519 -361 1142 -801 623 -441 1137 -803 1143 -805 7 -2 4604 5211 5163 5856 l44 50 -7377 0 -7377 0 38 -45z">
                </path>
                <path id="pSpXxwMJJ" d="M15310 13878 c-1427 -1557 -2596 -2833 -2597 -2837 -1 -3 1006 -760 2238 -1681 1231 -921 2239 -1678 2239 -1682 0 -3 -1744 -1469 -3875 -3257 l-3875 -3251 -3678 3110 -3677 3109 -139 156 c-76 86 -139 163 -140 171 0 8 896 701 2014 1557 1108 848 2015 1545 2015 1549 0 3 -1114 1239 -2475 2745 l-2475 2739 -2 -236 c-9 -805 -73 -7918 -74 -8157 l-1 -292 3631 -3146 c1996 -1730 3633 -3144 3635 -3143 3 2 94 -85 203 -192 243 -241 334 -313 528 -422 409 -229 837 -242 1249 -36 175 88 287 169 456 332 69 67 1762 1527 3763 3246 l3637 3125 0 4663 c0 2564 -1 4662 -2 4661 -2 0 -1171 -1274 -2598 -2831z m-8520 -11243 c228 -228 413 -415 410 -415 -3 0 -192 187 -420 415 -228 228 -413 415 -410 415 3 0 192 -187 420 -415z m920 -930 c206 -206 373 -375 370 -375 -3 0 -174 169 -380 375 -206 206 -373 375 -370 375 3 0 174 -169 380 -375z">
                </path>
                <path id="pZejLqGTn" d="M6918 10402 l-2317 -1807 -1 -792 0 -793 4790 0 4790 0 0 868 -1 867 -2463 1729 c-1354 952 -2467 1731 -2472 1733 -5 1 -1052 -811 -2326 -1805z">
                </path>
            </g>
        </g>
    </svg>
    )
}

export default EmailRegisterIcon;